<template>
	<div>
		<div v-if="src == null || src === ''" :class="small ? 'm-1' : 'm-3'"><div :style="imagesTool.avatar(src, small ? 2.5 : 11)" :class="initialsAvatarClass"><span :class="small ? 'initials-small' : 'initials'">{{ userName }}</span></div></div>
		<div v-else :class="small ? 'm-1' : 'm-3'"><div :style="imagesTool.avatar(src, small ? 2.5 : 11)"></div></div>
	</div>
</template>

<script>
import imagesTool from '@/tools/images';

export default {
	name: 'user-avatar',
	methods: {
		
	},
	props: {
		small: {
			type: Boolean,
			default: false
		},
		propUser: {
			type: Object,
			requred: false,
		}
	},
	data: function () {
		return {
			imagesTool
		};
	},
	computed: {
		profile () {
			return this.$store.getters.getProfile
		},
		initialsAvatarClass () {
			if (this.small) {
				return 'avatar-sm';
			}
			return 'avatar-md';
		},
		src () {
			if (this.propUser) return this.propUser.avatar;
			return this.profile.avatar;
		},
		userName () {
			if (this.propUser) return this.mixinGetInitials(this.propUser.name);
			return this.mixinGetInitials(this.profile.name);
		}
	}
};
</script>